import React from 'react';
import { 
    WMSTileLayer
} from 'react-leaflet';


function SigPACLayer({ opacity = 1 }) {
    return <WMSTileLayer
        layers={'AU.Sigpac:recinto'}
        styles='recinto'
        format='image/png'
        version='1.3.0'
        transparent
        url="https://sigpac-hubcloud.es/wms"
        opacity={opacity}
    />
}


export default SigPACLayer;